import type {
  ActivityTableRow,
  TableQueryOpts,
  TableSortableColumn,
} from "@/types/table.types";
import { TABLE_SORTABLE_COLUMNS } from "@/types/table.types";
import { applyBasicFilters } from "@/utils/demo.utils";
import { loadDemoActivities } from "./demoStore";

export async function fetchTableActivitiesDemo(
  q: TableQueryOpts,
): Promise<{ rows: ActivityTableRow[]; total: number }> {
  const all = await loadDemoActivities();
  const rows = applyBasicFilters(all, q);

  const total = rows.length;

  const sortId: TableSortableColumn =
    q.sortBy?.id && TABLE_SORTABLE_COLUMNS.includes(q.sortBy.id)
      ? q.sortBy.id
      : "start_date";
  const desc = q.sortBy?.desc ?? true;

  rows.sort((a, b) => {
    const av = a[sortId];
    const bv = b[sortId];

    if (av == null && bv == null) return 0;
    if (av == null) return desc ? 1 : -1;
    if (bv == null) return desc ? -1 : 1;

    if (av < bv) return desc ? 1 : -1;
    if (av > bv) return desc ? -1 : 1;
    return 0;
  });

  const pageSize = Math.max(1, Math.min(q.pageSize, 200));
  const from = q.pageIndex * pageSize;
  const to = from + pageSize;

  return { rows: rows.slice(from, to), total };
}
